<div style="width: 100%;height: 100%;">
    <div class="loader">
       <div class="wrapper">
         <div class="circle"></div>
       </div>
 
     </div>
 </div>
  
 